import $ from 'jquery';
import BaseEvent from './base-event';

export default class LanguageEvents extends BaseEvent {
    constructor() {
        super({
            event_id: '5',
            category: 'language',
            action: 'click',
        });

        this.$langDialogCont = $('.locale-selector-modal');

        this.init();
    }

    init() {
        this.onCloseEvent();
        this.onNewLangEvent();
        this.onSocialNameEvent();
    }

    onCloseEvent() {
        this.$langDialogCont.find('.btn-close').on('click', () => {
            this.fireEvent({
                label: 'close',
            });
        });
    }

    onNewLangEvent() {
        this.$langDialogCont.find('.locale-selector-item > a').on('click', (e) => {
            this.fireEvent({
                label: this.toNormalizedString(e.currentTarget.title),
                destination_url: e.currentTarget.href,
            });
        });
    }

    onSocialNameEvent() {
        $(document).on('click', '.locale-selector-item__social a', (e) => {
            this.fireEvent({
                label: this.toNormalizedString(e.currentTarget.title),
                destination_url: e.currentTarget.href,
            });
        });
    }
}
